import React, { useState, useEffect } from "react";
import "./sortablelabel.scss";

const SortableLabel = ({ order, text, enabled = true, onSort, style = {}, className = "", testid }) => {
  const [direction, setDirection] = useState("none");

  useEffect(() => {
    setDirection(order);
  }, [order]);

  const doSort = () => {
    if (!enabled) {
      return;
    }
    let newDirection = direction;
    if (direction === "asc" || direction === "up") {
      newDirection = "desc";
    }
    if (direction === "desc" || direction === "down") {
      newDirection = "none";
    }
    if (direction === "none") {
      newDirection = "asc";
    }
    setDirection(newDirection);
    if (onSort) {
      onSort(newDirection);
    }
  };

  return (
    <div
      style={{ ...style }}
      className={`${className} sortablelabel pointer`}
      onClick={() => doSort()}
      {...(testid ? { "data-testid": testid } : {})}
    >
      <span>{text}</span>
      {enabled && (direction === "none" || direction === "asc" || direction === "up") && <span className="caret up" />}
      {enabled && (direction === "none" || direction === "desc" || direction === "down") && (
        <span className="caret down" />
      )}
    </div>
  );
};

export default SortableLabel;
